export default __webpack_public_path__ + "static/media/625.e34f20d8.jpg";